import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useThemeStyles } from '@shared/theme/use-theme-styles'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { CalendarPicker, LocalizationProvider } from '@mui/x-date-pickers'
import { pl } from 'date-fns/locale'

export const RequirementCalendarDialog = ({
  open,
  onClose,
  onConfirm,
}: {
  open: boolean
  onClose: () => void
  onConfirm: (date: Date) => void
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  // const classes = useStyles()
  const sharedClasses = useThemeStyles()

  const handleDateChange = (newDate: Date | null) => {
    if (newDate) {
      setSelectedDate(newDate)
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pl}>
      <Dialog open={open} fullWidth maxWidth="sm">
        <DialogTitle className={sharedClasses.dialogTitle}>
          Ustaw datę obowiązywania alertu
        </DialogTitle>
        <DialogContent dividers>
          <CalendarPicker
            date={selectedDate}
            onChange={handleDateChange}
            disablePast
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose()} color="primary" variant="outlined">
            Anuluj
          </Button>
          <Button
            onClick={() => onConfirm(selectedDate)}
            color="primary"
            variant="contained"
          >
            Zapisz
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  )
}

const useStyles = makeStyles(() => {
  return {}
})
